import { createSelector } from '@atlassian/eoc-rss-helpers';

import { type ScheduleEntity } from '../../../services/endpoints/list/types';
import { type initialState } from '../state';
import { OverrideVariant } from '../state/types';

const getShiftRelatedModalOpen = createSelector<
	typeof initialState,
	// Hook input
	ScheduleEntity,
	// Selector output
	boolean,
	// Selector inputs
	boolean,
	boolean,
	ScheduleEntity | undefined,
	OverrideVariant | undefined,
	ScheduleEntity
>(
	(state, _) => state.isAddOverrideOpen,
	(state, _) => state.isRevertOverrideOpen,
	(state, _) => state.activeSchedule,
	(state, _) => state.overrideVariant,
	(_, schedule) => schedule,
	(isAddOverrideOpen, isRevertOverrideOpen, activeSchedule, overrideVariant, schedule) => {
		if (schedule?.id !== activeSchedule?.id) {
			return false;
		}

		if (isRevertOverrideOpen) {
			return true;
		}

		if (isAddOverrideOpen) {
			if (
				overrideVariant === OverrideVariant.Edit ||
				overrideVariant === OverrideVariant.Customize
			) {
				return true;
			}
		}

		return false;
	},
);

export const selectors = {
	getShiftRelatedModalOpen,
};
